import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GameState, IGameRepresentation, IGameStateChangedArgs, IGameRepresentationChangedArgs, BoxNumberCallboard, IBoxNumberCallboardItem, IBoxNumberCallboardBox, IBoxNumberCallboardPrize } from '@/components/game/_domain/models';
import TombolaBaseComponent from '@/components/base/base.component';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { PrizeHelper } from '@/components/game/_domain/helpers/prize-helper';
import { safeCast } from '@/helper';

@Component({
  name: 'BoxNumberCallboardComponent',
})
export default class BoxNumberCallboardComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private isVisible: boolean = true;
  private boxNumberCallboard: BoxNumberCallboard = null;
  public prizeHelper: PrizeHelper = new PrizeHelper();

  private get boxNumberCallboardItems(): IBoxNumberCallboardItem[] {
    return this.boxNumberCallboard ? this.boxNumberCallboard.items : [];
  }

  private get boxNumberCallboardBoxes(): IBoxNumberCallboardBox[] {
    return this.boxNumberCallboard ? this.boxNumberCallboard.boxes : [];
  }

  private get boxNumberCallboardPrizes(): IBoxNumberCallboardPrize[] {
    return this.boxNumberCallboard ? this.boxNumberCallboard.prizes : [];
  }

  private mounted(): void {
    const game = this.gameController.getGame();
    this.updateVisibility(game.state);
    this.update(game.representation);

    Vue.nextTick(() => {
      this.gameController
        .onGameStateChanged(this.handleGameStateChanged)
        .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    const gameState = eventArgs.currentGameState;
    this.updateVisibility(gameState);
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation = eventArgs.currentGameRepresentation;
    this.update(gameRepresentation);
  }

  private updateVisibility(gameState: GameState) {
    this.isVisible = gameState !== GameState.WinnersDisplayed;
  }

  private update(gameRepresentation: IGameRepresentation) {
    this.boxNumberCallboard = gameRepresentation.boxNumberCallboard;
  }

  public formatPrize(prize: number | string) {
    if (typeof (prize) === 'string') {
      return this.prizeHelper.formatPrize(safeCast(prize, 0));
    } else {
      return this.prizeHelper.formatPrize(prize);
    }
  }

  public shouldShowPrize(box: IBoxNumberCallboardItem) {
    if (box.isPlayerBox) {
      return false;
    }

    if (box.isCalled) {
      return true;
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/box-number-callboard/box-number-callboard.component.ts